import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from '../../OnlineTeachersForHirePage.module.css';

const IconCard = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg  className={classes} width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_171_27048)">
        <path fillRule="evenodd" clipRule="evenodd" d="M79.5857 73.2001C78.7778 74.484 77.0897 74.883 75.7925 74.0967C66.804 69.2434 56.0182 69.0582 46.8684 73.6001C46.6177 77.209 43.617 80.0085 39.9994 80.0085C36.3819 80.0085 33.3812 77.209 33.1305 73.6001C23.9807 69.0582 13.1949 69.2434 4.20634 74.0967C2.90917 74.883 1.22109 74.484 0.413238 73.2001C-0.246855 72.1439 -0.104771 70.7742 0.758066 69.876C0.923104 69.7067 1.10841 69.5584 1.30979 69.4346C2.0822 68.9656 19.9581 56.0415 39.9994 68.9656C60.0408 56.0415 77.9305 68.9656 78.6891 69.4346C78.892 69.5675 79.0814 69.7199 79.2546 69.8898C80.1065 70.7888 80.2427 72.1502 79.5857 73.2001Z" fill="#E64C3C"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M62.2614 46.7998C61.307 45.4794 59.9749 44.4791 58.4407 43.9308C53.8062 42.3032 47.1166 41.4618 39.9993 47.6687C32.8821 41.4618 26.1924 42.3032 21.5579 43.9308C20.0237 44.4791 18.6917 45.4794 17.7372 46.7998L0.744141 69.8481L0.757934 69.8756C0.922972 69.7064 1.10828 69.5581 1.30966 69.4343C13.5187 62.7287 28.4517 63.4102 39.9993 71.1998C51.5465 63.4089 66.4802 62.7275 78.689 69.4343C78.8919 69.5671 79.0813 69.7196 79.2545 69.8894L79.2683 69.8756L62.2614 46.7998Z" fill="#F5EFCA"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M79.269 69.8756L79.2552 69.8894C79.082 69.7196 78.8926 69.5671 78.6897 69.4343C66.4809 62.7275 51.5472 63.4089 40 71.1998V47.6687C47.1172 41.4618 53.8069 42.3032 58.4414 43.9308C59.9756 44.4791 61.3077 45.4794 62.2621 46.7998L79.269 69.8756Z" fill="#F9EAB0"/>
        <path d="M39.9998 38.6207C50.6646 38.6207 59.3101 29.9752 59.3101 19.3103C59.3101 8.64554 50.6646 0 39.9998 0C29.335 0 20.6895 8.64554 20.6895 19.3103C20.6895 29.9752 29.335 38.6207 39.9998 38.6207Z" fill="#4FBA6F"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M33.1035 30.3448C32.7377 30.3447 32.3869 30.1993 32.1283 29.9407L26.611 24.4234C26.1435 23.8752 26.1768 23.0594 26.6873 22.551C27.1979 22.0426 28.0137 22.0129 28.56 22.4827L33.1738 27.0965L51.5186 11.3724C52.0996 10.9116 52.941 10.9926 53.4234 11.5559C53.9057 12.1191 53.8564 12.9629 53.3117 13.4662L34.0014 30.0179C33.7506 30.2304 33.4322 30.3463 33.1035 30.3448Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_171_27048">
          <rect width="80" height="80" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

IconCard.defaultProps = {
  className: null,
  rootClassName: null,
};

IconCard.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconCard;
